module.exports = __webpack_public_path__ + "static/media/check1.3c8a54b4.svg";